/**
 * @module Auth認証
 */
export default {
  name: 'CameraAuth',
  /** @type {Methods} */
  methods: {
    /**
     * HomeLink画面を開く
     */
    OAuthCheck: function () {
      let url = process.env.VUE_APP_HOME_LINK_URL + 'open-api/v1/elife/oauth2/authorize?';
      let client_id = 'client_id=' + localStorage.getItem('client_id');
      let response_type = '&response_type=code';
      let state = '&state=' + localStorage.getItem('state');
      let redirect_uri = location.href + '/' + localStorage.getItem('oneTimeUrlId');
      // console.log("redirect_uri", redirect_uri);
      const encodeUrl = encodeURIComponent(redirect_uri);
      let redirectUri = '&redirect_uri=' + encodeUrl;
      let authUrl = url + client_id + response_type + state + redirectUri;
      // console.log("homelinkへのURL", authUrl);
      window.location.href = authUrl;
    },

    /**
     * お知らせダイアログ
     */
    OAuthError: async function () {
      const result = await this.$informationDialog(
        '$vuetify.メッセージ一覧.FECU52新規メインユーザー登録画面仮登録.E0025'
      );
      if (result === true) {
        window.close();
      }
    },
    /**
     * APP_CO9914 カメラ認証完了通知
     * @param {string} code code
     * @param {string} state state
     */
    APP_CO9914: async function (code, state) {
      let param = '/api/common/cameraAuth'; //本番用
      // let param = "post"; //検証用
      // let param = "atus/400";

      let queries = {
        oneTimeUrlId: this.$route.params.oneTimeUrlID,
        code: code,
        state: state,
      };

      let method = 'post';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            // 自動でタブを閉じる
            window.close();
          },
          (error /* eslint-disable-line */) => {
            // 自動でタブを閉じる
            window.close();
          }
        );
      // console.log("APP_CO9914>>>", apiData);
    },
  },
  async mounted() {
    // URLからパラメーター解析＆取得
    var query = window.location.href.split('?')[1];
    if (!query) {
      console.log('OAuth認証');
      // クエリにcodeとstateを保持していない場合
      // OAuth認証
      this.OAuthCheck();
    } else {
      // console.log('APP_CO9914');
      // クエリにcodeとstateを保持
      // 検証用 http://~~/?state=bbb&code=aaa#/cameraAuth/onetime1234
      // 検証用 http://~~/?code=aaa&state=bbb#/cameraAuth/onetime1234
      var split = query.split('#');
      var split2 = split[0].split('&');
      var params1 = split2[0].split('=');
      var params2 = split2[1].split('=');
      let state = '';
      let code = '';
      if (params1[0] == 'state' && params2[0] == 'code') {
        state = params1[1];
        code = params2[1];
      } else {
        state = params2[1];
        code = params1[1];
      }
      await this.APP_CO9914(code, state);
    }
  },
};
